import { ModalConfirmation, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import { getDeleteDraftConfirmationModalTitle } from '../../utils/getDeleteDraftConfirmationModalTitle'

interface DeleteDraftConfirmationModalProps extends ModalProps {
  documentType: InvoiceDocumentType
  isDeleting?: boolean
  onOk?: () => void
}

const DeleteDraftConfirmationModalComponent = ({
  documentType,
  id,
  isDeleting,
  onOk,
}: DeleteDraftConfirmationModalProps) => {
  const { t } = useTranslation()

  const title = useMemo(() => {
    return getDeleteDraftConfirmationModalTitle(documentType, t)
  }, [documentType, t])

  const handleDeleteModalOkClick = useCallback(() => {
    onOk?.()
  }, [onOk])

  return (
    <ModalConfirmation
      cancelLabel={t('external_invoices.editor.confirm_delete_draft_modal.cancel_button')}
      danger
      id={id}
      message={t('external_invoices.editor.confirm_delete_draft_modal.description')}
      okLabel={t('external_invoices.editor.confirm_delete_draft_modal.delete_button')}
      okLoading={isDeleting}
      onOk={handleDeleteModalOkClick}
      title={title}
    />
  )
}

export const DeleteDraftConfirmationModal = withModalConditionalRender(DeleteDraftConfirmationModalComponent)
